// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"3810":"11e478bc","6265":"ef91b213"}[chunkId] + ".chunk.css");